// ###########################################
// # variaveis de configuração do sistema    #
// ###########################################

// Garante uso de HTTPS em localhost para evitar redirect 307 que remove o header Authorization
const getApiBase = () => {
  const base = process.env.REACT_APP_APIBASE || "";
  if (base.startsWith("http://localhost:54017")) {
    return base.replace("http://localhost:54017", "https://localhost:44320");
  }
  return base;
};

var globals = {
  REACT_APP_APIBASE: getApiBase(),
  REACT_APP_ENDERECO: process.env.REACT_APP_ENDERECO,
  REACT_APP_CATALOGO: process.env.REACT_APP_CATALOGO,
};
export default globals;
